import { Button, Col, Form, Row, Section, message } from 'ui';
import { type NewPasswordFormContentValues, useGetErrorMessage } from 'features/settings';
import { useResetPasswordMutation } from '../../queries';
import { NewPasswordExpiredFormContent, type NewPasswordExpiredFormValues } from './new-password-expired-form-content';

type P = {
  email?: string;
  onNavigateToPrimaryLogin: () => void;
  onSuccessChangePassword: () => void;
};

const NewPasswordExpiredForm = ({ email, onNavigateToPrimaryLogin, onSuccessChangePassword }: P) => {
  const initialValues = { email };

  const getErrorMessage = useGetErrorMessage();

  const { isPending: isLoading, mutate: changePassword } = useResetPasswordMutation();

  const onFinish = (data: NewPasswordFormContentValues) => {
    changePassword(
      { ...data },
      {
        onError(error) {
          const { duration, errorMessage } = getErrorMessage(error);
          message.error(errorMessage, { duration });
        },
        onSuccess() {
          message.success('Your password was successfully changed');
          onSuccessChangePassword();
        },
      },
    );
  };

  return (
    <Form<NewPasswordExpiredFormValues> className="login-form" initialValues={initialValues} onFinish={onFinish}>
      <NewPasswordExpiredFormContent<NewPasswordExpiredFormValues> />
      <Section lineBottom={false} lineTop={false} paddingBottom={false} paddingTop>
        <Row gutter={[0, 'ms']}>
          <Col span={24}>
            <Button block htmlType="submit" loading={isLoading} type="primary">
              Reset password
            </Button>
          </Col>
          <Col span={24}>
            <Button
              block
              onClick={() => {
                onNavigateToPrimaryLogin();
              }}
            >
              Back to Log in
            </Button>
          </Col>
        </Row>
      </Section>
    </Form>
  );
};

export default NewPasswordExpiredForm;
